import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAISummaryInDisputeCommentsByRecordingUseCase {
    _aiRepository: AIRepository;
    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }
    public call = async (record: string): Promise<any> => {
        return await this._aiRepository.GetAISummaryInDisputeCommentsByRecord(record);
    }
}

export const GetAISummaryInDisputeCommentsByRecordingUseCaseName = "GetAISummaryInDisputeCommentsByRecordingUseCaseName";